import styles from "./Introduction.module.css";

const Introduction = () => {
  return (
    <header className={styles.header}>
      <h1 className={styles.h1}>Hi I'm Luka Kviatkovski</h1>
      <h2 className={styles.h2}>And This Is My Portfolio Page</h2>
    </header>
  );
};

export default Introduction;
